import React from 'react';
import './PrecisionWater.css';

const PrecisionWater = () => {
  const features = [
    {
      icon: 'fas fa-crosshairs',
      title: 'Perfect Placement',
      description: 'Computer vision and GPS guidance ensure each dripper is positioned exactly where plants need water most, eliminating guesswork and human error.'
    },
    {
      icon: 'fas fa-tint',
      title: 'Water Conservation',
      description: 'Precise dripper placement reduces water waste by up to 42%, helping farmers save on water costs while maintaining healthy crops even in drought conditions.'
    },
    {
      icon: 'fas fa-chart-line',
      title: 'Smart Monitoring',
      description: 'Real-time data collection helps farmers optimize watering schedules and detect issues early, leading to healthier crops and higher yields.'
    }
  ];

  return (
    <section className="precision-water">
      <div className="container">
        <h2>Precision Water Delivery</h2>
        <p className="section-subtitle">
          Our intelligent robots place drippers with millimeter precision, ensuring optimal water distribution and maximizing crop yield while minimizing water waste.
        </p>
        
        <div className="precision-features">
          {features.map((feature, index) => (
            <div key={index} className="precision-feature">
              <div className="feature-icon">
                <i className={feature.icon}></i>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
        
        <div className="water-savings">
          <h3>Measurable Water Savings</h3>
          <div className="savings-stats">
            <div className="stat">
              <div className="stat-number green">42%</div>
              <div className="stat-label">Less Water Usage</div>
            </div>
            <div className="stat">
              <div className="stat-number blue">95%</div>
              <div className="stat-label">Placement Accuracy</div>
            </div>
            <div className="stat">
              <div className="stat-number light">30%</div>
              <div className="stat-label">Higher Yields</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrecisionWater;
